export default "__VITE_ASSET__BRXljHXd__"